import script from "./ProfileNotificationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileNotificationCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfileNotificationCard.vue?vue&type=style&index=0&id=78d68f53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d68f53"]])

export default __exports__